import React, { useEffect, useState } from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import CheckYourPhone from '@/components/CheckYourPhone';
import QrCode from '@/components/QRCode';
import ScreenLockIcon from "@assets/svg/mobile-portrait-mode-icon.svg";
import {
  getSelectorsByUserAgent,
  BrowserTypes,
  OsTypes,
} from 'react-device-detect';
import { getTemplate } from '@/api/http';
import { PRODUCT_PATHS } from '@/api/constants';

const ScreenLock = () => (
  <div className="flex flex-col h-screen justify-center items-center -mt-3.5">
    <ScreenLockIcon style={{ width: 100, height: 100, marginBottom: 10 }} />
    <h1 className="text-base font-semibold">Landscape mode is not supported</h1>
    <p className="font-normal">Please turn your phone to Portrait mode</p>
  </div>
);

export interface IPageProps { isMobile: boolean, children: any; }

const MobileOnly = ({ isMobile, children }: IPageProps) => {
  const router = useRouter();
  const { variant } = router.query;
  const [showScreenLock, setScreenLock] = useState(false);

  if (!isMobile && variant === "drive") {
    return <CheckYourPhone />;
  }

  if (!isMobile) {
    return <QrCode />;
  }

  useEffect(() => {
      const handler = (e: MediaQueryListEvent) => {
        if (e.matches) { // isLandscape
          if (!BrowserTypes.Safari && !OsTypes.IOS) {
            const screen = window.screen.orientation;
            // @ts-expect-error - "lock" is missing in the ScreenOrientation type in typescript@5.3.3
            screen.lock("portrait").then(() => {
              console.log("orientation locked");
            }).catch((error: any) => {
              console.error("Unable to lock orientation:", error);
              setScreenLock(true);
            });
          } else {
            setScreenLock(true);
          }
        } else {
          setScreenLock(false);
        }
      }
      const landscapeMode = window.matchMedia("(orientation: landscape)");
      if (landscapeMode.matches) {
        setScreenLock(true);
      }
      landscapeMode.addEventListener("change", handler);
      return () => landscapeMode.removeEventListener("change", handler);
  }, []);

  if (showScreenLock) {
    return <ScreenLock />;
  }

  return children;
}

const getServerSideProps: GetServerSideProps = async ({ req, params }) => {
  const userAgent = req && req.headers["user-agent"] || "";
  const { isMobile } = getSelectorsByUserAgent(userAgent);
  const isAvaId = req.url?.split("/").filter(Boolean)[0] === PRODUCT_PATHS.AVA_ID;
  
  if (req.url && isAvaId) {
    // HANDLE STRIPE ID PROVIDER
    const template = await getTemplate(params?.leadId as string);
    if (template.provider === "stripe" && template.redirectUrl && !template.alreadyVerified) {
      return {
        redirect: {
          destination: template.redirectUrl,
          permanent: false,
        },
      }
    }
  }

  return {
    props: {
      isMobile,
      ...params,
    }
  }
}

export { MobileOnly, getServerSideProps };
